"use strict";

var _slicedToArray = require("/home/circleci/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/slicedToArray");

var _objectWithoutProperties = require("/home/circleci/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/objectWithoutProperties");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _emotionTheming = require("emotion-theming");

var _HeaderLogo = _interopRequireDefault(require("../../../HeaderLogo"));

var _MenuSlider = _interopRequireDefault(require("../../../MenuSlider"));

var _BurgerButton = _interopRequireDefault(require("../../../BurgerButton"));

var _AccountNav = require("../../../../AccountNav/AccountNav");

var _helpers = require("../../../../../utils/helpers");

var _PrimaryNav = require("./PrimaryNav.style");

var PrimaryMenu = function PrimaryMenu(_ref) {
  var links = _ref.links,
      homeLink = _ref.homeLink,
      active = _ref.active,
      account = _ref.account,
      isLargeNav = _ref.isLargeNav,
      isLargeSlider = _ref.isLargeSlider,
      secondaryActions = _ref.secondaryActions,
      variation = _ref.variation,
      rest = _objectWithoutProperties(_ref, ["links", "homeLink", "active", "account", "isLargeNav", "isLargeSlider", "secondaryActions", "variation"]);

  var _ref2 = (0, _emotionTheming.useTheme)(),
      header = _ref2.header,
      colors = _ref2.colors;

  var logoProps = {
    color: colors[header.logo.color],
    height: header.logo.height,
    width: header.logo.width
  }; // clean up to make sure scrolling is always enabled when navigating to a new page or unmounting the component

  (0, _react.useEffect)(function () {
    return (0, _helpers.lockWindow)(false);
  }, []);

  var _ref3 = (0, _react.useState)(false),
      _ref4 = _slicedToArray(_ref3, 2),
      isNavOpen = _ref4[0],
      setIsNavOpen = _ref4[1];

  var toggleNav = function toggleNav() {
    setIsNavOpen(!isNavOpen);
    (0, _helpers.lockWindow)(!isNavOpen);
  };

  return /*#__PURE__*/_react.default.createElement(_PrimaryNav.PrimaryMenuWrapper, rest, /*#__PURE__*/_react.default.createElement(_PrimaryNav.NavWrapper, null, /*#__PURE__*/_react.default.createElement(_PrimaryNav.LogoWrapper, null, /*#__PURE__*/_react.default.createElement(_HeaderLogo.default, Object.assign({
    homeLink: homeLink
  }, logoProps))), links && isLargeNav && links.map(function (link, key) {
    return /*#__PURE__*/_react.default.createElement(_PrimaryNav.NavLink, {
      key: key.toString(),
      to: link.url,
      onClick: link.onClick,
      enhanced: true // TODO - the isActive is leaking all the way to the link and breaks the html standard
      // we are passing as string for now to mitigate multiple warning that hinder development
      ,
      active: (active === link.url).toString()
    }, link.label);
  }), !isLargeNav && /*#__PURE__*/_react.default.createElement(_PrimaryNav.BurgerWrap, null, /*#__PURE__*/_react.default.createElement(_BurgerButton.default, {
    toggled: false,
    toggle: setIsNavOpen,
    onClick: toggleNav
  }))), /*#__PURE__*/_react.default.createElement(_MenuSlider.default, {
    links: links,
    isNavOpen: isNavOpen,
    setIsNavOpen: setIsNavOpen,
    isLargeNav: isLargeSlider,
    toggleNav: toggleNav,
    account: account,
    secondaryActions: secondaryActions,
    variation: variation
  }));
};

PrimaryMenu.propTypes = {
  account: _propTypes.default.shape(_AccountNav.accountPropTypes),
  active: _propTypes.default.string,
  secondaryActions: _propTypes.default.arrayOf(_propTypes.default.shape({
    label: _propTypes.default.string,
    url: _propTypes.default.string,
    startIcon: _propTypes.default.string
  })),
  homeLink: _propTypes.default.string,
  links: _propTypes.default.arrayOf(_propTypes.default.shape({
    label: _propTypes.default.string,
    url: _propTypes.default.string,
    description: _propTypes.default.string,
    navItems: _propTypes.default.arrayOf(_propTypes.default.shape({
      label: _propTypes.default.string,
      url: _propTypes.default.string
    }))
  })),
  isLargeNav: _propTypes.default.bool,
  isLargeSlider: _propTypes.default.bool,
  variation: _propTypes.default.oneOf(['primary'])
};
PrimaryMenu.defaultProps = {
  account: null,
  active: null,
  secondaryActions: [],
  homeLink: '/',
  links: [],
  isLargeNav: false,
  isLargeSlider: false,
  variation: 'primary'
};
var _default = PrimaryMenu;
exports.default = _default;